export default "__VITE_ASSET__88578f71__"